import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import PackageDetail from './pages/PackageDetail';
import PackagesPage from './pages/PackagesPage';
import { Toaster } from './components/ui/toaster';
import WhatsAppFab from './components/WhatsAppFab';

function ScrollToTopOnMount() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTopOnMount />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/packages" element={<PackagesPage />} />
          <Route path="/packages/:id" element={<PackageDetail />} />
        </Routes>
        <WhatsAppFab />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
